import TabsController from '../../tabs_controller'

// 施設種別タブの表示切替。切替ロジックの本体は TabsController 側にある。
export default class extends TabsController {
  datasetKey () {
    return 'categoryId'
  }

  // テンプレート（common/component.rb の tab_html_options）の data-action が参照するaction名
  switchCategory (event) {
    this.switchTab(event)
  }
}
